import sImg1 from "../images/services/icon-1.svg";
import simg2 from "../images/services/icon-2.svg";
import simg3 from "../images/services/icon-3.svg";
import simg4 from "../images/services/icon-4.svg";

const services = [
  {
    id: "1",
    img: sImg1,
    title: "Content Planning",
    description:
      "Kami membantu merancang strategi konten Anda secara terstruktur untuk meningkatkan jangkauan dan keterlibatan audiens.",
  },
  {
    id: "2",
    img: simg2,
    title: "Design Feed",
    description:
      "Kami membantu mendesain feed media sosial Anda secara menarik untuk memperkuat branding dan meningkatkan daya tarik visual.",
  },
  {
    id: "3",
    img: simg3,
    title: "Video Content",
    description:
      "Kami membantu membuat konten video yang kreatif dan profesional untuk memperkuat pesan dan meningkatkan daya tarik audiens.",
  },
  {
    id: "4",
    img: simg4,
    title: "Research Content",
    description:
      "Kami membantu melakukan riset konten secara mendalam untuk memastikan ide dan strategi Anda relevan serta berbasis data.",
  },
  {
    id: "5",
    img: simg2,
    title: "Copy Writing",
    description:
      "Kami membantu membuat tulisan yang persuasif dan menarik untuk memperkuat pesan dan meningkatkan konversi bisnis Anda.",
  },
  {
    id: "6",
    img: simg2,
    title: "Admin Posting",
    description:
      "Kami membantu mengelola jadwal dan posting konten Anda secara konsisten untuk menjaga aktivitas dan engagement di media sosial.",
  },
];

export default services;
